export enum UserStatus {
  isNoStamp = 1,
  canDonate,
  isDonated,
  isNoQuota,
  canMoreDonate,
}

export type NGOInfo = {
  // 活动累计捐贈印花数
  totalSendNum: number;
  // 活动当日捐贈印花数
  daySent: number;
  // 活动当日捐贈日限额
  dayLimit: number;
  // 活动 id 加密串
  enActid: string;
  // 密文兑换活动奖品id
  prizeId: string;
  // 用户对每个 NGO 活动的捐贈数量
  hasGot: number;
  // 捐赠次数
  donateCount: number;
  // 用户今日已捐赠次数
  userTodayDonatedCount: number;
};

export type GoodDeedDayNGOType = {
  // NGO 关键词
  key: string;
  // NGO 机构名
  name: string;
  // NGO 机构名
  enName: string;
  // NGO 主页介绍
  desc: string;
  // NGO 主页介绍
  descEn: string;
  // NGO logo
  logo: string;
  // NGO 详细介绍
  content: string;
  // NGO 联系方式
  contact: string;
  // NGO 宣传图
  pic: string;
  // 展示权重
  order: string;
  // 分享弹窗图片
  sharepic: string
};

export type GoodDeedDayNewsType = {
  // 资讯图片
  newsPic: string;
  // 资讯标题
  newsTitle: string;
  // 资讯地址
  newsUrl: string;
  // 展示权重
  order: string;
};
